// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

import { base } from './baseEnvironment';

export const environment = {
  ...base,
  production: false,
  auth0ClientId: '3viqYHVZl4b08LUJErkmeQRASqCSCeCi',
  apiUrl: 'https://api-testing.qualitybidders.net',
  auth0CallbackUrl: 'https://testing.qualitybidders.net/auth-callback',
  ssoDomains: ['https://testing.colbisecurebids.com'],
  sbUrl: 'https://testing.colbisecurebids.com',
  site: 'ca',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
